import api, { ApiResponse } from './api';

export interface UserSettings {
  cdn_token_refresh_enabled: string;
  [key: string]: string;
}

export const userSettingsService = {
  async get(): Promise<UserSettings> {
    const response = await api.get<ApiResponse<UserSettings>>('/user-settings');
    return response.data.data;
  },

  async update(data: Partial<UserSettings>): Promise<UserSettings> {
    const response = await api.put<ApiResponse<UserSettings>>('/user-settings', data);
    return response.data.data;
  },
};
